// client/ui/CAdminDocumentationManager.js
import { ComponentBase } from "../../core/ComponentBase.js";

export class CAdminDocumentationManager extends ComponentBase {
    constructor(config) {
        super(config);
        this.docManagerComponent = null;
        this.currentContextId = null;
        this.currentContextType = null;
    }

    async initialize() {
        await super.initialize();
    }

    // async onShow() {
    //     await this.loadContentBasedOnRoute();
    // }
    
    async refresh() {
        await this.loadContentBasedOnRoute();
    }

    async initAfterLogin() {
        await this.loadContentBasedOnRoute();
    }

    async loadContentBasedOnRoute() {
        const queryParams = this.appClient.layoutEngine.getQueryParams();
        const contextIdFromRoute = queryParams.contextId;
        const contextTypeFromRoute = queryParams.contextType;

        if (this.currentContextId === contextIdFromRoute && 
            this.currentContextType === contextTypeFromRoute && 
            this.docManagerComponent) {
            // Already managing this context, or no context specified and already cleared
            if (!contextIdFromRoute && !this.docManagerComponent) return;
            if (contextIdFromRoute && this.docManagerComponent) return;
        }

        this.currentContextId = contextIdFromRoute;
        this.currentContextType = contextTypeFromRoute;

        if (this.docManagerComponent) {
            this.docManagerComponent.destroy();
            this.docManagerComponent = null;
        }

        if (this.currentContextId && this.currentContextType) {
            // Use the app-facing workspace root with a fixed course context.
            this.docManagerComponent = await this.createManagedComponent('DocumentWorkspaceManager', null, {
                instanceId: `${this.config.instanceId || 'cadminContextDocs'}-docmanager-${this.currentContextId}`,
                contextId: this.currentContextId, 
                contextType: this.currentContextType,
                syncProjectContext: false,
                provider: this.config.provider || 'kbmWorkspace'
            });
        }

        if (this.container) {
            await this.render();
        }
    }

    async render() {
        if (!this.container) {
            this.container = document.createElement('div');
            this.container.className = 'cadmin-documentation-manager-container h-100';
        }
        this.container.innerHTML = '';

        if (!this.currentContextId || !this.currentContextType) {
            const placeholder = document.createElement('div');
            placeholder.className = 'alert alert-info m-3 text-center';
            placeholder.innerHTML = `<i class="bi bi-book-half me-2"></i> ${this.t('Select a course via "Manage Content" to edit its documentation spaces.')}`;
            this.container.appendChild(placeholder);
        } else if (this.docManagerComponent) {
            this.container.appendChild(await this.docManagerComponent.render());
        } else {
            const loadingMsg = document.createElement('div');
            loadingMsg.className = 'p-3 text-muted text-center';
            loadingMsg.textContent = this.t('Loading Content Editor...');
            this.container.appendChild(loadingMsg);
        }
        this.appClient.tx.applyTranslations(this.container);
        return this.container;
    }

    destroy() {
        this.docManagerComponent?.destroy();
        this.docManagerComponent = null;
        super.destroy();
    }
}
